import React from 'react';
import styled from 'styled-components';
import { minResolution } from 'util/helpers';
import icRadiobuttonOn1x from 'assets/images/common/@1x/ic_radiobutton_on.png';
import icRadiobuttonOn2x from 'assets/images/common/@2x/ic_radiobutton_on@2x.png';
import icRadiobuttonOn3x from 'assets/images/common/@3x/ic_radiobutton_on@3x.png';
import icRadiobuttonOff1x from 'assets/images/common/@1x/ic_radiobutton_off.png';
import icRadiobuttonOff2x from 'assets/images/common/@2x/ic_radiobutton_off@2x.png';
import icRadiobuttonOff3x from 'assets/images/common/@3x/ic_radiobutton_off@3x.png';

const Radio = ({ ...props }) => <input type="radio" {...props} />;

export default styled(Radio)`
  height: 30px;
  width: 30px;
  appearance: none;
  outline: none;
  background-color: transparent;
  border: none;

  &::after {
    display: inline-block;
    width: 30px;
    height: 30px;
    background-image: url('${icRadiobuttonOff1x}');
    background-size: 30px;
    content: '';
    cursor: pointer;

    ${minResolution(2)`
      background-image: url('${icRadiobuttonOff2x}');
    `}

    ${minResolution(3)`
      background-image: url('${icRadiobuttonOff3x}');
    `}
  }

  &:checked::after {
    background-image: url('${icRadiobuttonOn1x}');

    ${minResolution(2)`
      background-image: url('${icRadiobuttonOn2x}');
    `}

    ${minResolution(3)`
      background-image: url('${icRadiobuttonOn3x}');
    `}
  }
`;



// WEBPACK FOOTER //
// ./src/components/common/Radio/index.js